<template>
  <div>
    <v-container>
      <SectionTitle :title="$tc('main.enums.sections.expected_supporting_documents', count)" />
      <div
        v-if="documentsList.length > 0"
        class="d-flex justify-space-between my-4"
      >
        <SmallSectionTitle :title="$tc('main.enums.sections.added-documents', documentsList.length)" />
      </div>
      <div v-if="documentsList.length > 0">
        <Documents
          :documents="documentsList"
          :isEditMode="isEditMode"
          @show-upload-modal="onShowUploadModal"
        />
      </div>
      <div
        v-if="missingDocuments.length > 0"
        class="my-4"
      >
        <SmallSectionTitle :title="$tc('main.enums.sections.missing-documents', missingDocuments.length)" />
      </div>
      <div
        v-if="missingDocuments.length > 0"
        class="my-4"
      >
        <Documents
          :documents="missingDocuments"
          :isEditMode="isEditMode"
          @show-upload-modal="onShowUploadModal"
        />
      </div>
    </v-container>
    <UploadFilesModal
      v-if="modalDocument"
      :isOpened="showUploadModal"
      :personId="selectedProfile.id"
      :documentId="modalDocument.id"
      :documentFiles="modalDocument.pages"
      :documentKind.sync="modalDocument.document_kind"
      :documentStatus="modalDocument.status || ''"
      :isInvalid="modalDocument.isInvalid"
      @close="showUploadModal = false"
      @updated="$emit('updated')"
    />
  </div>
</template>

<script type="text/javascript">
  import mixinUi from '@/mixins/utils/ui.js'
  import CommonMixin from '@/mixins/store/CommonMixin.js'
  import mixinCurrency from '@/mixins/utils/currency.js'
  import { uniqBy } from '@/utils/common.utils'

  import SectionTitle from '@/components/ui/common/SectionTitle'
  import Documents from '@/components/common/Documents/Documents'
  import SmallSectionTitle from '@/components/ui/common/SmallSectionTitle'
  import UploadFilesModal from '@/components/ui/common/UploadFilesModal/UploadFilesModal'
  import { DOCUMENT_CHECK_STATUSES } from '@/components/ui/inputs/FileInput.const'

  export default {
    components: {
      UploadFilesModal,
      Documents,
      SectionTitle,
      SmallSectionTitle,
    },
    mixins: [mixinUi, CommonMixin, mixinCurrency,],
    props: {
      isEditMode: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        checks: {},
        showUploadModal: true,
        modalDocument: null,
      }
    },
    computed: {
      count() {
        return this.documentsList.length + this.missingDocuments.length
      },
      documentsList() {
        const list = uniqBy(this.selectedProfile.supporting_documents, (i) => i.document_kind)
        const refusedDocuments = this.selectedProfile.meta.refused_documents

        return list
          .filter((item) => item.pages.length > 0)
          .map((data) => {
            const refusedIndex = refusedDocuments.indexOf(data.document_kind)
            const isRefused = refusedIndex >= 0

            const status = isRefused ? DOCUMENT_CHECK_STATUSES.isInvalid : DOCUMENT_CHECK_STATUSES.isSuccess

            return {
              id: data.document_kind,
              date: data.updated_at,
              status,
              data,
            }
          })
      },
      missingDocuments() {
        return this.selectedProfile.meta.missing_documents.map((missingDocumentKind) => {
          const emptyDocument = this.selectedProfile.supporting_documents.find(
            (document) => document.document_kind === missingDocumentKind
          )

          if (emptyDocument) {
            return {
              id: emptyDocument.document_kind,
              date: emptyDocument.updated_at,
              status: DOCUMENT_CHECK_STATUSES.isMissing,
              data: emptyDocument,
            }
          }

          return {
            id: missingDocumentKind,
            status: DOCUMENT_CHECK_STATUSES.isMissing,
          }
        })
      },
    },
    mounted() {
      this.checks = this.selectedProfile.person_controls[0].checks
    },
    methods: {
      onShowUploadModal(document) {
        const modalDocument = document.data || {
          document_kind: document.id,
          document_status: '',
          pages: [],
        }
        modalDocument.isInvalid = document.status === DOCUMENT_CHECK_STATUSES.isInvalid

        this.modalDocument = modalDocument

        this.showUploadModal = true
      },
    },
  }
</script>
